module.exports = __webpack_public_path__ + "static/media/AB_O1_15.60b8a219.jpg";